import React from "react";
import { ClipboardList, Search, HardHat, Sparkles } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const stepIcons = [ClipboardList, Search, HardHat, Sparkles];

export default function Process() {
  const { ref, visible } = useScrollReveal();

  const processSteps = [
    {
      number: 1,
      title: "Request an Estimate",
      desc: "Tell us about your project."
    },
    {
      number: 2,
      title: "Project Review",
      desc: "We review the area, requirements and scope of work."
    },
    {
      number: 3,
      title: "Preparation & Pour",
      desc: "Our crew prepares the site and completes the concrete work."
    },
    {
      number: 4,
      title: "Finishing",
      desc: "We finish the project with attention to quality and detail."
    }
  ];

  return (
    <section className="bg-[hsl(var(--navy))] py-20 md:py-28 concrete-texture relative overflow-hidden">
      {/* Rebar trace background */}
      <div className="absolute inset-0 rebar-trace opacity-30" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div
          ref={ref}
          className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-0.5 bg-[hsl(var(--card))]" />
            <span className="section-label text-[#194d32] text-base">
              HOW IT WORKS
            </span>
            <div className="w-8 h-0.5 bg-[hsl(var(--card))]" />
          </div>
          <h2 className="headline text-white text-4xl sm:text-5xl md:text-6xl">
            From Estimate to Finished Concrete
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {processSteps.map((step, i) => {
            const Icon = stepIcons[i];
            return (
              <div
                key={step.number}
                className="bg-[hsl(var(--navy))] p-8 group hover:bg-[hsl(var(--navy))]/80 transition-colors"
                style={{
                  opacity: visible ? 1 : 0,
                  transform: visible ? "translateY(0)" : "translateY(24px)",
                  transition: `all 0.6s ease-out ${i * 0.12}s`
                }}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="mono-number text-5xl text-[#ffffff]">
                    {`0${step.number}`}
                  </span>
                  <Icon size={32} className="text-[#194d32]" />
                </div>
                <h3 className="font-heading text-xl text-white tracking-wide mb-2 uppercase">
                  {step.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}